'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: ', ';\n  justify-content: center;\n  align-items: ', ';\n'], ['\n  display: flex;\n  flex-direction: ', ';\n  justify-content: center;\n  align-items: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n      column\n    '], ['\n      column\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        column-reverse\n      '], ['\n        column-reverse\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n        row\n      '], ['\n        row\n      ']),
    _templateObject5 = _taggedTemplateLiteral(['\n        row-reverse\n      '], ['\n        row-reverse\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n          column\n        '], ['\n          column\n        ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: white;\n  padding: ', ' ', ';\n  border-radius: ', ';\n  margin: 0;\n'], ['\n  background-color: ', ';\n  color: white;\n  padding: ', ' ', ';\n  border-radius: ', ';\n  margin: 0;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  margin: 0;\n  margin-left: ', ';\n'], ['\n  margin: 0;\n  margin-left: ', ';\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  fill: ', ';\n'], ['\n  fill: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
  var position = _ref.position;

  switch (position) {
    case 'top':
      return (0, _styledComponents.css)(_templateObject2);

    case 'bottom':
      return (0, _styledComponents.css)(_templateObject3);

    case 'left':
      return (0, _styledComponents.css)(_templateObject4);

    case 'right':
      return (0, _styledComponents.css)(_templateObject5);

    default:
      return (0, _styledComponents.css)(_templateObject6);
  }
}, function (_ref2) {
  var position = _ref2.position;
  return position === 'top' || position === 'bottom' ? '' : 'center';
});
var Message = _styledComponents2.default.p(_templateObject7, function (props) {
  return props.error ? function (_ref3) {
    var theme = _ref3.theme;
    return theme.color.dangerPopup;
  } : function (_ref4) {
    var theme = _ref4.theme;
    return theme.color.primary;
  };
}, (0, _polished.rem)(10), (0, _polished.rem)(10), (0, _polished.rem)(4));

var Triangle = _styledComponents2.default.svg(_templateObject8, function (_ref5) {
  var position = _ref5.position;
  return position === 'top' || position === 'bottom' ? (0, _polished.rem)(10) : 0;
});

var Polygon = _styledComponents2.default.polygon(_templateObject9, function (props) {
  return props.error ? function (_ref6) {
    var theme = _ref6.theme;
    return theme.color.dangerPopup;
  } : function (_ref7) {
    var theme = _ref7.theme;
    return theme.color.primary;
  };
});

function MessagePopup(props) {
  var points = void 0;
  switch (props.position) {
    case 'bottom':
      points = '0 10, 15 10, 7.5 0';
      break;
    case 'left':
      points = '0 0, 10 7.5, 0 15';
      break;
    case 'right':
      points = '10 0, 10 15, 0 7.5';
      break;
    default:
      points = '0 0, 15 0, 7.5, 10';
  }
  return _react2.default.createElement(
    Wrapper,
    { position: props.position },
    _react2.default.createElement(
      Message,
      { error: props.error },
      props.message
    ),
    _react2.default.createElement(
      Triangle,
      {
        position: props.position,
        error: props.error,
        width: props.position === 'top' || props.position === 'bottom' ? '15' : '10',
        height: props.position === 'top' || props.position === 'bottom' ? '10' : '15'
      },
      _react2.default.createElement(Polygon, { points: points, error: props.error })
    )
  );
}

MessagePopup.propTypes = {
  message: _propTypes2.default.string,
  error: _propTypes2.default.bool,
  position: _propTypes2.default.string
};

MessagePopup.defaultProps = {
  message: '',
  error: false,
  position: 'top'
};

exports.default = MessagePopup;
MessagePopup.__docgenInfo = [{
  'description': '',
  'displayName': 'MessagePopup',
  'methods': [],
  'props': {
    'message': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'\'',
        'computed': false
      }
    },
    'error': {
      'type': {
        'name': 'bool'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': 'false',
        'computed': false
      }
    },
    'position': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '\'top\'',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/MessagePopup/index.js'] = {
    name: 'MessagePopup',
    docgenInfo: MessagePopup.__docgenInfo,
    path: 'src/MessagePopup/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/MessagePopup/index.js
// module id = 319
// module chunks = 1